import { Component } from '@mna/react'
import Clinics from 'features/Clinics'
import PopupModel from "features/PopupModel";
import IconPhone from "assets/icons/phone.svg";
import {Trans} from 'react-i18next'
import i18next from 'i18next';
import {
  checkAndGetLocalStorageValue
} from "../../../features/utils";


export default class EmergencySessionResults extends Component {

  state = {
    isShowingHeader: true
  }

  render() {

    const { state, actions, history, previousStepName, nextStepName } = this.props
    const {
      emergencySessionResults = {}
    } = state.triageResponse

    const customStyles = {
      content: {
        top: "50%",
        left: "44%",
        right: "auto",
        bottom: "auto",
        marginRight: "-50%",
        transform: "translate(-50%, -50%)",
      },
    };
    const customStylesMobile = {
      content: {
        top: "50%",
        left: "50%",
        right: "auto",
        bottom: "auto",
        marginRight: "-50%",
        transform: "translate(-50%, -50%)",
      },
    };

    const customStyles1 = {
      content: {
        top: "20%",
        left: "50%",
        right: "50%",
        bottom: "60%",
        marginRight: "-50%",
        transform: "translate(-50%, -50%)",
      },
    };
    
    const { markers = [], clinics = [] } = emergencySessionResults
    return (
      <Clinics
        {...{
          state,
          actions,
          history,
          clinics,
          markers,
          header: this.state.isShowingHeader ? (
            state.isFacility || state.triageRequest.isFacilitySearch ? (
              <div>
                {!clinics[0] ? (
                  <PopupModel
                    isOpen={true}
                    modelContent={
                      <div>
                        <Trans i18nKey="findcareoption.Careoptions.housevisit.RecommendedCareOptionsMsg1"></Trans>
                      </div>
                    }
                    buttonLabel={
                      <Trans i18nKey="findcareoption.Covid.Continue_text">
                        Continue
                      </Trans>
                    }
                    buttonStyle="button standby-button standby-button-gradient standby-button-gradient-green"
                    buttonType="button"
                    onClick={() => {
                      if(state.isFacility){
                      history.push({
                        pathname: "/find-facility",
                        search:
                          "?organizationId=" +
                          checkAndGetLocalStorageValue("orgid"),
                      });
                    }else{
                      history.push({
                        pathname: "/find-care-options/location",
                      });
                    }}
                  }
                    style={clinics.length == 0 &&
                      state.msg !=
                        "We could not find a matching service"
                        ? window.innerWidth <= 834
                          ? customStylesMobile
                          : customStyles
                        : state.msg ==
                          "We could not find a matching service"
                        ? customStyles1
                        : ""}
                  ></PopupModel>
                ) : (
                  ""
                )}{" "}
              </div>
            ) : (
              <div className="standby-emergency-banner">
                <div className="standby-emergency-banner-inner">
                  <div className="standby-emergency-banner-text">
                    <h1 className="standby-page-header-title">
                      <Trans i18nKey="findcareoption.Careoptions.emergencyoptions.EmergencyTitle">
                        Nearby Emergency Rooms
                      </Trans>
                    </h1>
                    <p>
                      <Trans i18nKey="findcareoption.Careoptions.emergencyoptions.EmergencyMsg1">
                        Please contact emergency services or make your way to a
                        nearby emergency room.
                      </Trans>
                    </p>
                  </div>
                  <div className="standby-emergency-card">
                    <div className="standby-emergency-card-label">
                      <Trans i18nKey="findcareoption.Careoptions.emergencyoptions.EmergencyMsg2">
                        The emergency number for your current location is:
                      </Trans>
                    </div>
                    {state.triageResponse.emergencyNumber.length >= 1 ? (
                      <div className="standby-emergency-card-number">
                        {state.triageResponse.emergencyNumber.map((item, index) => (
                          <div className="standby-emergency-button-padding">
                            <a key={index} href={`tel:${item}`}>
                              {item}
                              <button role="button" key={`phonebtn${index}`} className="button standby-button standby-button-call">
                                <div key={`phone${index}`} className="icon">
                                  <IconPhone />
                                </div>
                                {i18next.t("findcareoption.Careoptions.emergencyoptions.call")}
                              </button>
                            </a>
                          </div>
                        ))}
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                  <button
                    className="button standby-close standby-emergency-banner-close"
                    onClick={() => this.setState({ isShowingHeader: false })}
                    aria-label='close'
                  >
                    ×
                  </button>
                </div>
              </div>
            )
          ) : null,
        }}
      />
    );
  }
}
